// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { useResizeObserver } from '../../internal/hooks/container-queries';
import { useCallback, useState } from 'react';
export function useObservedElement(selectorOrRef) {
  var getElement = useCallback(function () {
    var _a, _b;
    if (typeof selectorOrRef === 'string') {
      return document.querySelector(selectorOrRef);
    } else if (typeof selectorOrRef === 'function') {
      return (_a = selectorOrRef()) !== null && _a !== void 0 ? _a : null;
    } else {
      return (_b = selectorOrRef === null || selectorOrRef === void 0 ? void 0 : selectorOrRef.current) !== null && _b !== void 0 ? _b : null;
    }
  }, [selectorOrRef]);
  var _a = useState(0),
    height = _a[0],
    setHeight = _a[1];
  useResizeObserver(getElement, function (entry) {
    return setHeight(entry.borderBoxHeight);
  });
  return height;
}